import React from 'react';
import { Link } from 'react-router-dom';

const MethodNotAllowedPage = () => {
  return (
    <div className="error-page">
      <h1>405 Method Not Allowed</h1>
      <p>The method used in the request is not allowed. Please check the request method and try again.</p>
      <Link to="/">Go back to Home</Link>
    </div>
  );
};

export default MethodNotAllowedPage;
